/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import "babel-polyfill";

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Accordion from './modules/accordion';
import Breadcrumbs from './modules/breadcrumbs';
import AutoComplete from './modules/search-autocomplete';
import DisciplineNav from './modules/discipline-nav';
import FilterPanel from './modules/filter-panel';
import HorseContact from './modules/horse-contact';
import GoogleMap from './modules/map';
import ModalData from './modules/modal-data';
import Monthpicker from './modules/monthpicker';
import RadioToggle from './modules/radio-toggle';
import ReadMore from './modules/read-more';
import RegionsMap from './modules/regions-map';
import SiteNav from './modules/site-nav';
import Tabs from './modules/tabs';
import TypeMate from 'typemate';
import ZoomedImg from './modules/zoomed-img';
import $ from "jquery";

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if(!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if(!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch(module) {

                    case 'accordion':

                        let accordionInstance = new Accordion(item);

                        accordionInstance.init();

                        break;

                    case 'breadcrumbs':

                        let breadcrumbsInstance = new Breadcrumbs(item);

                        breadcrumbsInstance.init();

                        break;

                    case 'discipline-nav':

                        let discplineNavInstance = new DisciplineNav(item);

                        discplineNavInstance.init();

                        break;

                    case 'filter-panel':

                        let filterPanelInstance = new FilterPanel(item);

                        filterPanelInstance.init();

                        break;

                    case 'monthpicker':

                        let monthpickerInstance = new Monthpicker(item);

                        monthpickerInstance.init();

                        break;

                    case 'regions-map':

                        let regionsMapInstance = new RegionsMap(item);

                        regionsMapInstance.init();

                        break;

                    case 'site-nav':

                        let siteNavInstance = new SiteNav(item);

                        siteNavInstance.init();

                        break;

                    case 'tabs':

                        let tabsInstance = new Tabs(item);

                        tabsInstance.init();

                        break;

                    case 'map':

                        let mapInstance = new GoogleMap(item);

                        mapInstance.init();

                        break;

                    case 'search-autocomplete':

                        let autocompleteInstance = new AutoComplete(item);

                        autocompleteInstance.init();

                        break;

                    case 'horse-contact':

                        let horseContactInstance = new HorseContact(item);

                        horseContactInstance.init();

                        break;

                    case 'read-more':

                        let readMoreInstance = new ReadMore(item);

                        readMoreInstance.init();

                        break;

                    case 'radio-toggle':

                        let radioToggleInstance = new RadioToggle(item);

                        radioToggleInstance.init();

                        break;

                    case 'modal-data':

                        let modalDataInstance = new ModalData(item);

                        modalDataInstance.init();

                        break;

                    case 'zoomed-image':

                        let zoomedImageInstance = new ZoomedImg(item);

                        zoomedImageInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        // TypeMate
        const typeMateInstance = new TypeMate();
        typeMateInstance.apply();

        // Helpline
        var elementPosition = $('#helpline').offset();
        $(window).on('scroll', function(){
            if($(window).scrollTop() > elementPosition.top){
                $('#helpline').css('right','-224px');
            } else {
                $('#helpline').css('right','0');
            }
        });
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    }
};

// Launch
app.init();
